
const JGApplicationId = 2;
export default JGApplicationId;


// WEBPACK FOOTER //
// ./src/utils/constants/applicationId.js